module.exports = __webpack_public_path__ + "static/img/056.e74491e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/lkpy/056.png
// module id = VIsZ
// module chunks = 0